import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  createUserWithEmailAndPassword,
  updateProfile
} from 'firebase/auth';
import { getFirestore, doc, setDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { auth, functions } from './firebase';

const db = getFirestore();

const SignUp = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [pin, setPin] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError('');

    // 1) Check password match
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    try {
      // 2) Verify PIN server-side (settings/parentPin is not client-readable)
      const verifyPin = httpsCallable(functions, 'verifyParentSignupPin');
      await verifyPin({ pin });

      // 3) Create user in Firebase Auth
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );

      // 4) Update display name
      await updateProfile(userCredential.user, { displayName: name });

      // 5) Create parent record in Firestore
      await setDoc(doc(db, 'parents', userCredential.user.uid), {
        name,
        email,
        accessEnabled: true,
        createdAt: new Date()
      });

      // 6) Redirect into the protected area
      navigate('/parents-only');
    } catch (err) {
      console.error(err);
      const code = err?.code || '';
      if (code === 'functions/permission-denied' || code === 'functions/invalid-argument') {
        setError('Invalid PIN code. Please contact your admin.');
        return;
      }
      setError('Failed to create account. Try a different email or stronger password.');
    }
  };

  return (
    <div className="login-page">
      <h1>Create Parent Account</h1>
      <form onSubmit={handleSignUp} style={{ maxWidth: '400px', margin: '0 auto' }}>
        <div className="form-group">
          <label>Name</label>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={e => setName(e.target.value)}
            required
            placeholder="Your full name"
          />
        </div>

        <div className="form-group mt-3">
          <label>Email</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            placeholder="Enter your email"
          />
        </div>

        <div className="form-group mt-3">
          <label>Password</label>
          <input
            type={showPassword ? 'text' : 'password'}
            className="form-control"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            placeholder="Create a password"
          />
        </div>

        <div className="form-group mt-3">
          <label>Confirm Password</label>
          <input
            type={showPassword ? 'text' : 'password'}
            className="form-control"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            required
            placeholder="Re-enter your password"
          />
        </div>

        <div className="form-group mt-3">
          <label>Parent PIN Code</label>
          <input
            type="text"
            className="form-control"
            value={pin}
            onChange={e => setPin(e.target.value)}
            required
            placeholder="Enter PIN from admin"
          />
        </div>

        <div className="form-group mt-2">
          <input
            type="checkbox"
            id="showPassword"
            checked={showPassword}
            onChange={() => setShowPassword(!showPassword)}
          />
          <label htmlFor="showPassword" style={{ marginLeft: '8px' }}>
            Show Password
          </label>
        </div>

        {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}

        <button type="submit" className="btn btn-teal mt-4">Sign Up</button>
      </form>
    </div>
  );
};

export default SignUp;
